module.exports = __webpack_public_path__ + "img/check-black.de39b18f.svg";